// extracted by mini-css-extract-plugin
module.exports = {"status":"GOLStatus_status__3eJRG","statusTag":"GOLStatus_statusTag__38jdA","statusValue":"GOLStatus_statusValue__1ELis"};